import { useLocation } from 'react-router-dom'; // fork(oem): Outlet moved into OemShell
import type { HierarchyLevel } from '@/shared/types';
import { TopBar } from '@/versions/v1/chrome/TopBar';
import { AppSidebar } from '@/versions/v1/chrome/AppSidebar';
import { SeededAnnouncementBanner } from '@/versions/v1/chrome/AnnouncementBanner';
import { Walkthrough } from '@/versions/v1/chrome/Walkthrough';
import { Drawer } from '@/versions/v1/chrome/Drawer';
import { AIRail } from '@/versions/v1/chrome/AIRail';
import { AppShellPanels } from '@/versions/v1/chrome/AppShellPanels';
import { OemShell } from '@/versions/v1/chrome-oem/OemShell'; // fork(oem): top bar + crumb + outlet
import { OemCommandPalette } from '@/versions/v1/chrome-oem/OemCommandPalette'; // fork(oem): replaces ThreadSpotlight
import { ToastHost } from '@/versions/v1/shared/toast/ToastHost'; // fork(oem): demo #toast
import { TourBar } from '@/versions/v1/chrome-oem/TourBar'; // fork(oem): guided tour bar
import { isChatFirstPath } from '@/versions/v1/shared/project-sidebar-nav';
import { useWalkthroughSync } from './use-walkthrough-sync';

function levelForPath(path: string): HierarchyLevel {
  if (path === '/login') return 'auth';
  if (path === '/' || path === '') return 'workspace';
  if (path.startsWith('/admin') || path.startsWith('/settings')) return 'workspace';
  if (path.startsWith('/projects/')) return 'project';
  return 'workspace';
}

export function AppLayout() {
  const location = useLocation();
  const level = levelForPath(location.pathname);
  // fork(oem): `/` is Asset360, an ordinary scene — not the foundation's
  // chat-first workspace home. Left as-is the AI rail is never mounted on the
  // product's home route, so `oem:ask` (the Today panel's "Ask" action and the
  // `<AskStrip>` chips) flips the rail flag but opens nothing.
  const chatFirst = location.pathname !== '/' && isChatFirstPath(location.pathname);
  const showAIRail = level !== 'auth' && !chatFirst;

  useWalkthroughSync();

  return (
    <div className="flex flex-col h-screen overflow-hidden text-ink-secondary">
      <SeededAnnouncementBanner />

      <main className="flex-1 flex overflow-hidden min-h-0">
        <AppSidebar />

        <AppShellPanels
          showRail={showAIRail}
          chrome={level !== 'auth' ? <TopBar level={level} /> : null}
          // fork(oem): was <Outlet />; OemShell wraps it in the OEM top bar + crumb
          main={<OemShell />}
          rail={<AIRail />}
        />
      </main>

      <Drawer />
      <Walkthrough />
      {/* fork(oem): <ThreadSpotlight /> replaced by the OEM palette + toast host */}
      <ToastHost />
      <TourBar /> {/* fork(oem): guided tour bar, hidden unless a tour is running */}
      <OemCommandPalette />
    </div>
  );
}
